export const isAgeConfirmed = state => state.customer.isAgeConfirmed;

export const getCustomerTempId = state => state.user.tempUser.id;



// WEBPACK FOOTER //
// ./src/selectors/customer_selectors.js